<template>
  <div class="contentDetails">
    <NavBar :navBlock="navBlock" :navtitle="navtitle" :pageBack="true"></NavBar>
    <div class="paddingContent">
      <div class="contentbox">
        <div class="contentLeft">
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">售後信息</div>
              <div style="display: flex" v-if="orderInfo.valid == 1">
                <div class="cardHeaderRight" v-if="orderInfo.status == 1">
                  <el-button
                    type="primary"
                    size="mini"
                    @click="showModal('success', '3')"
                  >
                    審核通過
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="showModal('supplement', '5')"
                  >
                    補充資料
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="showModal('fail', '4')"
                  >
                    審核不通過
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="showModal('chuli', '9')"
                  >
                    直接處理
                  </el-button>
                </div>
                <div class="cardHeaderRight" v-else-if="orderInfo.status == 5">
                  <el-button
                    type="primary"
                    size="mini"
                    style="
                      background-color: #fff;
                      color: #5938e0;
                      border: 1px solid #e1e0e6;
                    "
                    @click="delCalendar()"
                  >
                    關閉售後
                  </el-button>
                </div>
                <div
                  class="cardHeaderRight"
                  v-else-if="
                    orderInfo.status == 6 ||
                    orderInfo.status == 7 ||
                    orderInfo.status == 3
                  "
                >
                  <el-button
                    type="primary"
                    style="
                      background-color: #fff;
                      color: #5938e0;
                      border: 1px solid #e1e0e6;
                    "
                    size="mini"
                    @click="delCalendar()"
                  >
                    關閉售後
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    style="
                      background-color: #fff;
                      color: #5938e0;
                      border: 1px solid #e1e0e6;
                    "
                    @click="showModal('yichang', '7')"
                    v-if="orderInfo.status != 7 && processingMethod != 2"
                  >
                    異常處理
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="showModal('yichangliuyan', '7')"
                    v-if="orderInfo.status == 7"
                  >
                    留言回復
                  </el-button>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="showModal('fahuo', '8')"
                  >
                    發貨
                  </el-button>
                </div>
              </div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in orderInfoLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div
                  style="color: #5938e0; font-size: 14px"
                  v-if="item.key == 'status'"
                >
                  {{ changeStatus(orderInfo[item.key]) }}
                </div>
                <div
                  style="display: flex; align-items: center"
                  v-else-if="item.key == 'processingMethod'"
                >
                  <div
                    style="color: #292929; font-size: 14px"
                    v-if="
                      orderInfo.status != 1 &&
                      orderInfo.status != 5 &&
                      orderInfo.status != 4
                    "
                  >
                    {{
                      orderInfo[item.key] == 1
                        ? "需要寄回商品"
                        : orderInfo[item.key] == 2
                        ? "無須寄回商品"
                        : "-"
                    }}
                  </div>
                  <div v-else style="color: #292929; font-size: 14px">-</div>
                  <div
                    @click="changeShowModal('changeMethd')"
                    class="changeMethd"
                    v-if="orderInfo.status == 3"
                  >
                    修改
                  </div>
                </div>
                <div
                  class="cardRowRight goodBox"
                  v-else-if="item.key === 'shopInformation'"
                >
                  <div
                    v-for="(item, index) in shopInformation"
                    :key="index"
                    class="good_head"
                    :style="{
                      borderBottom:
                        index == shopInformation.length - 1
                          ? 'none'
                          : '1px solid #d3d1db',
                    }"
                  >
                    <div class="good_item">
                      <img
                        style="width: 70px; height: 70px; border-radius: 4px"
                        :src="item.goodImg"
                      />
                      <div>
                        <div style="font-size: 14px; color: #252525">
                          {{ item.goodsName }}
                        </div>
                        <div
                          style="
                            font-size: 14px;
                            color: #d3d1db;
                            margin-top: 10px;
                          "
                        >
                          {{ item.goodSpecial }}
                        </div>
                      </div>
                    </div>
                    <div class="good_num">x{{ item.num }}</div>
                  </div>
                </div>
                <div class="cardRowRight" v-else-if="orderInfo[item.key]">
                  {{ orderInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
              <div
                v-for="(item, index) in dto"
                :key="index"
                :style="{
                  backgroundColor: index % 2 == 1 ? '#ECECEC' : '',
                  margin: '20px -20px 0 -20px',
                  padding: index % 2 == 1 ? '10px 20px' : '0px 20px',
                }"
              >
                <div class="cardRow">
                  <div class="cardRowLeft">
                    {{ index == 0 ? " 詳細説明：" : "補充説明：" }}
                  </div>
                  <div class="cardRowRight">{{ item.describe }}</div>
                </div>
                <div class="cardRow" style="margin-top: 20px">
                  <div class="cardRowLeft">
                    {{ index == 0 ? "憑證照片：" : "補充憑證：" }}
                  </div>
                  <div style="display: flex; flex-wrap: wrap">
                    <div
                      v-for="(items, indexs) in item.imgUrl"
                      :key="indexs"
                      class="cardRowRight allpointer"
                      style="position: relative; margin-right: 20px"
                    >
                      <el-image
                        style="width: 80px; height: 80px; border-radius: 4px"
                        :initial-index="indexs"
                        :src="item.imgUrl[indexs]"
                        :preview-src-list="item.imgUrl"
                      >
                      </el-image>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="cardRow"
                style="margin-top: 20px"
                v-if="orderInfo.memo && orderInfo.status == 4"
              >
                <div class="cardRowLeft">拒絕理由</div>
                <div class="cardRowRight">{{ orderInfo.memo }}</div>
              </div>
            </div>
          </div>
          <div
            class="box-card"
            v-if="
              (orderInfo.weReceiveAddr ||
                orderInfo.userTrackingType ||
                orderInfo.userReceiveAddr) &&
              orderInfo.processingMethod == 1
            "
          >
            <div class="cardHeader">
              <div class="cardHeaderLeft">退回地址及退回物流</div>
              <div
                v-if="orderInfo.status != 10 || orderInfo.status != 2"
                class="xiugaibox"
                @click="changeInfo('tuihui')"
                style="cursor: pointer"
              >
                修改
              </div>
            </div>
            <div class="cardBody">
              <div class="cardRow">
                <div class="cardRowLeft">退回地址：</div>
                <div class="cardRowRight" style="flex: 1">
                  {{ orderInfo.weReceiveAddr }}
                </div>
              </div>
              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">收件人：</div>
                <div class="cardRowRight">
                  {{ orderInfo.weReceiver }}
                </div>
              </div>
              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">手機號碼：</div>
                <div class="cardRowRight">
                  +{{ orderInfo.weReceiveAreaCode }}
                  {{ orderInfo.weReceivePhone }}
                </div>
              </div>

              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">退回物流公司：</div>
                <div class="cardRowRight">
                  {{
                    orderInfo.userTrackingType
                      ? orderInfo.userTrackingType
                      : "-"
                  }}
                </div>
              </div>
              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">退回貨運單號：</div>
                <div class="cardRowRight">
                  {{
                    orderInfo.userTrackingNumber
                      ? orderInfo.userTrackingNumber
                      : "-"
                  }}
                </div>
              </div>
            </div>
          </div>
          <div
            class="box-card"
            v-if="
              orderInfo.userReceiveAddr ||
              orderInfo.weTrackingNumber ||
              orderInfo.weTrackingType
            "
          >
            <div class="cardHeader">
              <div class="cardHeaderLeft">換貨發貨信息</div>
              <div
                v-if="orderInfo.status != 10 && orderInfo.status != 2"
                class="xiugaibox"
                @click="changeInfo('huanhuo')"
                style="cursor: pointer"
              >
                修改
              </div>
            </div>
            <div class="cardBody">
              <div class="cardRow">
                <div class="cardRowLeft">發貨地址：</div>
                <div class="cardRowRight" style="flex: 1">
                  {{ orderInfo.userReceiveAddr }}
                </div>
              </div>
              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">收件人：</div>
                <div class="cardRowRight">
                  {{ orderInfo.userReceiver ? orderInfo.userReceiver : "-" }}
                </div>
              </div>
              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">手機號碼：</div>
                <div class="cardRowRight">
                  +{{ orderInfo.userReceiveAreaCode }}
                  {{
                    orderInfo.userReceivePhone
                      ? orderInfo.userReceivePhone
                      : "-"
                  }}
                </div>
              </div>
              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">物流貨運：</div>
                <div class="cardRowRight">
                  {{
                    orderInfo.weTrackingType ? orderInfo.weTrackingType : "-"
                  }}
                </div>
              </div>
              <div class="cardRow" style="margin-top: 20px">
                <div class="cardRowLeft">貨運單號：</div>
                <div class="cardRowRight">
                  {{
                    orderInfo.weTrackingNumber
                      ? orderInfo.weTrackingNumber
                      : "-"
                  }}
                </div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">處理記錄</div>
            </div>
            <div class="cardBody">
              <div
                class="cardRow recordList"
                v-for="(item, index) in recordList"
                :key="index"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div
                  :class="index == 0 ? 'recordBoxWeight' : 'recordBox'"
                ></div>
                <div style="flex: 1">
                  <div
                    class="cardRowRight"
                    style="color: #5938e0; flex: 1; margin-bottom: 12px"
                  >
                    {{ $getTime(item.createTime) }}
                  </div>
                  <div class="cardRowRight" v-if="item.type == 3">
                    <div v-if="item.processingMethod != 0">
                      <div class="commonText">
                        {{ changeRecord(item.type) }}
                      </div>
                      <div class="commonText" style="margin-top: 12px">
                        處理方式：
                        <span style="color: #292929; font-size: 14px">{{
                          item.processingMethod == 1
                            ? "需要寄回商品"
                            : "無需寄回商品"
                        }}</span>
                      </div>
                    </div>
                    <div
                      class="commonText"
                      v-if="item.contentV2"
                      style="margin-top: 12px"
                    >
                      {{ item.contentV2 }}
                    </div>
                    <div
                      class="commonText"
                      v-if="item.content"
                      style="margin-top: 12px"
                    >
                      <span class="commonText"> 留言：</span
                      ><span style="color: #292929; font-size: 14px">{{
                        item.content
                      }}</span>
                    </div>
                  </div>
                  <div class="cardRowRight" v-else-if="item.content">
                    <div class="commonText" v-if="item.type == 15">
                      售後流程已完成
                    </div>
                    <div class="commonText">
                      {{ changeRecord(item.type)
                      }}<span
                        v-if="item.type == 15"
                        style="color: #292929; font-size: 14px"
                        >{{ item.content }}</span
                      >
                    </div>
                    <div
                      class="commonText"
                      style="margin-top: 12px"
                      v-if="item.type != 15"
                    >
                      <span class="commonText">{{
                        item.type == 4 ? "原因：" : "留言："
                      }}</span
                      ><span style="color: #292929; font-size: 14px">{{
                        item.content
                      }}</span>
                    </div>
                  </div>
                  <div v-else class="cardRowRight" style="color: #878399">
                    {{ changeRecord(item.type) }}
                  </div>
                  <div
                    class="cardRowRight"
                    style="margin-top: 12px"
                    v-if="item.type == 7 && item.processingMethod"
                  >
                    <span class="commonText"> 標記問題類型：</span
                    >{{ subType(item.processingMethod) }}
                  </div>
                  <div
                    class="cardRowRight"
                    style="margin-top: 12px"
                    v-if="item.type == 11 || item.type == 12"
                  >
                    <div class="commonText">
                      <span class="commonText">補充説明：</span
                      ><span style="color: #292929; font-size: 14px">{{
                        item.reason
                      }}</span>
                    </div>
                    <div
                      class="commonText"
                      v-if="item.imgUrl"
                      style="display: flex; margin-top: 12px"
                    >
                      <span class="commonText">補充憑證：</span>
                      <div
                        v-for="(items, indexs) in item.imgUrl"
                        :key="indexs"
                        class="cardRowRight allpointer"
                        style="position: relative; margin-right: 20px"
                      >
                        <el-image
                          style="width: 80px; height: 80px; border-radius: 4px"
                          :initial-index="indexs"
                          :src="item.imgUrl[indexs]"
                          :preview-src-list="item.imgUrl"
                        >
                        </el-image>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="contentRight">
          <div class="box-card" v-if="this.orderInfo.orderType != '活動'">
            <div class="cardHeader">
              <div class="cardHeaderLeft">收件人資訊</div>
              <!-- <div class="cardHeaderRight_edit" @click="showEdit()">
                編輯
              </div> -->
            </div>
            <div class="cardBody">
              <div
                class="cardRow"
                v-for="(item, index) in receiverLabel"
                :key="item.key"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="cardRowLeft">{{ item.label }}</div>
                <div class="cardRowRight" v-if="receiverInfo[item.key]">
                  {{ receiverInfo[item.key] }}
                </div>
                <div class="cardRowRight" v-else>-</div>
              </div>
            </div>
          </div>
          <div class="box-card">
            <div class="cardHeader">
              <div class="cardHeaderLeft">商品詳情</div>
            </div>
            <div class="cardBody">
              <div
                class="shoplist"
                v-for="(item, index) in orderDetailDto"
                :key="item.id"
                :style="{ marginTop: index === 0 ? '0px' : '20px' }"
              >
                <div class="shoplist_top">{{ item.goodsName }}</div>
                <div class="shoplist_bottom">
                  <div class="shoplist_detail" v-if="item.goodsType != 2">
                    {{ item.goodsDetail }}
                  </div>
                  <div class="shoplist_detail" v-else></div>
                  <div style="display: flex">
                    <div class="shoplist_num">×{{ item.goodsAmount }}</div>
                    <div style="margin-left: 20px">
                      <div class="shoplist_price">
                        {{ item.goodsRecievablePrice }}{{ currency }}
                        <div
                          class="priceLine"
                          v-if="
                            item.goodsReceiptsPrice !==
                            item.goodsRecievablePrice
                          "
                        ></div>
                      </div>
                      <div
                        style="font-size: 14px; color: #7d54ec"
                        v-if="
                          item.goodsReceiptsPrice !== item.goodsRecievablePrice
                        "
                      >
                        {{ item.goodsReceiptsPrice }}{{ currency }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="line"></div>
              <div class="shop_row">
                <div class="texttypelow">小計</div>
                <div class="texttypelow" v-if="discountRecievablePrice">
                  {{ discountRecievablePrice }}{{ currency }}
                </div>
                <div class="texttypelow" v-else>
                  {{ recievablePrice }}{{ currency }}
                </div>
              </div>
              <div class="shop_row">
                <div class="texttypelow">運費</div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-end;
                  "
                >
                  <div class="texttypelow" style="position: relative">
                    {{ extraPrice }}{{ currency }}
                    <div v-if="discountExtraPrice" class="priceLine"></div>
                  </div>
                  <div
                    style="color: #7d54ec; font-size: 0.14rem"
                    v-if="discountExtraPrice"
                  >
                    {{ discountExtraPrice }}{{ currency }}
                  </div>
                </div>
              </div>
              <div class="shop_row">
                <div class="texttypedeep">總金額</div>
                <div class="texttypedeep">
                  {{ receiptsPrice }}{{ currency }}
                </div>
              </div>
            </div>
          </div>
          <div class="remark_box">
            <div class="remark_box_input">
              <div class="remark_box_text">版工備註：</div>
              <el-input
                type="textarea"
                style="flex: 1"
                :rows="3"
                placeholder="请输入版工備註"
                v-model="remark"
                maxlength="100"
              >
              </el-input>
            </div>
            <div class="remark_box_button">
              <div
                class="btn borderBtn"
                @click="reset()"
                style="margin-right: 30px"
              >
                清空重置
              </div>
              <div class="btn" @click="handleSave()">確認保存</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 审核弹框 -->
    <el-dialog
      :title="
        addressType == 'success'
          ? '審核通過'
          : addressType == 'add'
          ? '新增退貨地址'
          : addressType == 'changeMethd'
          ? '修改處理方式'
          : '提示'
      "
      :visible.sync="editAddress"
      width="600px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
      :show-close="addressType == 'add' ? false : true"
    >
      <div v-if="addressType == 'success' || addressType == 'changeMethd'">
        <div style="display: flex">
          <div style="width: 120px">處理方式：</div>
          <div style="flex: 1">
            <el-radio-group v-model="processingMethod">
              <el-radio :label="1">需要用戶寄回商品</el-radio>
              <el-radio :label="2">無需用戶寄回商品</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div
          style="display: flex; margin-top: 20px"
          v-if="processingMethod == 1"
        >
          <div style="width: 120px">請選擇退回地址：</div>
          <div style="flex: 1">
            <div
              v-for="item in addressList"
              :key="item.id"
              style="margin-bottom: 10px; display: flex"
            >
              <el-radio
                v-model="addressId"
                :label="item.id"
                style="width: 80%; white-space: normal; word-wrap: break-word"
              >
                {{ item.receiveAddr }}
              </el-radio>
              <div
                style="color: #5938e0; cursor: pointer"
                @click="deleteAddress(item.id)"
              >
                删除
              </div>
            </div>
            <div
              v-if="addressList.length > 0"
              class="btn"
              style="text-align: center"
              @click="addressType = 'add'"
            >
              新增退貨地址
            </div>
            <div class="tui_btn" @click="addressType = 'add'" v-else>
              +新增退貨地址
            </div>
          </div>
        </div>
        <div style="display: flex; margin-top: 30px">
          <div style="width: 120px">留言:</div>
          <textarea
            v-if="processingMethod == 1"
            class="chart_input"
            v-model="content"
            maxlength="200"
            placeholder="非必填，請填寫審核通過原因"
          ></textarea>
          <textarea
            v-else
            class="chart_input"
            v-model="contents"
            maxlength="200"
            placeholder="必填，需提示用戶正確操作步驟"
          ></textarea>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-top: 30px">
          <div
            class="btn borderBtn"
            style="margin-right: 30px; text-align: center"
            @click="editAddress = false"
          >
            取消
          </div>
          <div
            class="btn"
            style="text-align: center"
            @click="changeOrder()"
            v-if="addressType == 'success'"
          >
            審核通過
          </div>
          <div
            class="btn"
            style="text-align: center"
            @click="changeMethod()"
            v-else
          >
            確認修改
          </div>
        </span>
      </div>
      <div v-else-if="addressType == 'add'">
        <el-form
          :model="addressForm"
          :rules="addressRule"
          ref="addressForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <div style="marginright: 110px">
            <el-form-item label="收件人" prop="receiver">
              <el-input
                v-model="addressForm.receiver"
                placeholder="请输入收件人姓名"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="區號" prop="receiveAreaCode">
              <el-input
                v-model="addressForm.receiveAreaCode"
                placeholder="请输入區號"
                maxlength="50"
                @input="
                  addressForm.receiveAreaCode =
                    addressForm.receiveAreaCode.replace(/\D+/g, '')
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="聯係電話" prop="receivePhone">
              <el-input
                v-model="addressForm.receivePhone"
                placeholder="请输入聯係電話"
                maxlength="50"
                @input="
                  addressForm.receivePhone = addressForm.receivePhone.replace(
                    /[^\d]/g,
                    ''
                  )
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="詳細地址" prop="receiveAddr">
              <el-input
                type="textarea"
                :rows="3"
                style="height: 100px"
                v-model="addressForm.receiveAddr"
                placeholder="请输入详细地址"
                maxlength="150"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer" style="margin-top: 30px">
          <div
            class="btn borderBtn"
            style="margin-right: 30px; text-align: center"
            @click="cancelAddress()"
          >
            取消
          </div>
          <div
            class="btn"
            style="text-align: center"
            @click="submitAddress('addressForm')"
          >
            保存
          </div>
        </span>
      </div>
      <div v-else-if="addressType == 'fahuo'">
        <el-form label-width="100px" class="demo-ruleForm">
          <div style="marginright: 110px">
            <el-form-item label="物流公司：">
              <el-input
                v-model="trackingForm.trackingType"
                placeholder="请输入物流公司"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="貨運單號：">
              <el-input
                v-model="trackingForm.trackingNumber"
                placeholder="请输入貨運單號"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer" style="margin-top: 30px">
          <div
            class="btn borderBtn"
            style="margin-right: 30px; text-align: center"
            @click="editAddress = false"
          >
            取消
          </div>
          <div class="btn" style="text-align: center" @click="changeOrder()">
            發貨
          </div>
        </span>
      </div>
      <div v-else>
        <div style="display: flex">
          <div style="width: 100px" v-if="addressType != 'fail'">留言：</div>
          <div style="flex: 1">
            <textarea
              class="chart_input"
              v-model="content"
              :maxlength="addressType == 'chuli' ? 150 : 200"
              :placeholder="
                addressType == 'fail'
                  ? '請輸入審核不通過原因'
                  : addressType == 'supplement'
                  ? '請提示用戶所需要補充的資料'
                  : addressType == 'chuli'
                  ? '必填，請填寫本次售後的最終處理說明'
                  : '請提示用戶物流異常原因'
              "
            ></textarea>
            <div
              style="color: #5938e0; font-size: 14px"
              v-if="addressType == 'chuli'"
            >
              提交後，該留言將發送給用戶，售後狀態將直接變更爲「已完成」，完成後將無法繼續留言。
            </div>
          </div>
        </div>
        <div
          style="display: flex; margin-top: 20px"
          v-if="addressType == 'yichang'"
        >
          <div style="width: 100px">標記問題類型：</div>
          <el-select
            style="flex: 1"
            v-model="processingMethod"
            placeholder="請選問題類型(非必填)，僅在管理平台處理記錄中顯示"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer" style="margin-top: 30px">
          <div
            class="btn borderBtn"
            style="margin-right: 32px; text-align: center"
            @click="editAddress = false"
          >
            取消
          </div>
          <div class="btn" style="text-align: center" @click="changeOrder()">
            {{
              addressType == "fail"
                ? "審核不通過"
                : addressType == "chuli"
                ? "售後處理完成"
                : "提交"
            }}
          </div>
        </span>
      </div>
    </el-dialog>
    <!-- 编辑物流 -->
    <el-dialog
      :title="
        editInfoType == 'tuihui' ? '编辑退回地址及退回物流' : '編輯換貨發貨信息'
      "
      :visible.sync="editwuliuModal"
      width="500px"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      center
    >
      <div class="dialog modalform" v-if="editInfoType == 'tuihui'">
        <el-form label-width="100px" class="demo-ruleForm">
          <div>
            <el-form-item label="收件人">
              <el-input
                maxlength="50"
                v-model="infoForm.weReceiver"
                placeholder="請輸入收件人"
              ></el-input>
            </el-form-item>
            <el-form-item label="區號">
              <el-input
                @input="
                  infoForm.weReceiveAreaCode =
                    infoForm.weReceiveAreaCode.replace(/\D+/g, '')
                "
                maxlength="50"
                v-model="infoForm.weReceiveAreaCode"
                placeholder="請輸入區號"
              ></el-input>
            </el-form-item>
            <el-form-item label="手機號碼">
              <el-input
                @input="
                  infoForm.weReceivePhone = infoForm.weReceivePhone.replace(
                    /\D+/g,
                    ''
                  )
                "
                maxlength="50"
                v-model="infoForm.weReceivePhone"
                placeholder="請輸入手機號碼"
              ></el-input>
            </el-form-item>
            <el-form-item label="退回地址" prop="trackingCompany">
              <el-input
                type="textarea"
                :rows="3"
                v-model="infoForm.weReceiveAddr"
                placeholder="請輸入退回地址"
                maxlength="150"
              ></el-input>
            </el-form-item>
            <el-form-item label="退回物流公司">
              <el-input
                maxlength="50"
                v-model="infoForm.userTrackingType"
                placeholder="請輸入退回物流公司"
              ></el-input>
            </el-form-item>
            <el-form-item label="退回貨運單號">
              <el-input
                maxlength="50"
                v-model="infoForm.userTrackingNumber"
                placeholder="請輸入退回貨運單號"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div class="dialog modalform" v-else>
        <el-form label-width="100px" class="demo-ruleForm">
          <div>
            <el-form-item label="收件人">
              <el-input
                maxlength="50"
                v-model="infoForm.userReceiver"
                placeholder="請輸入收件人"
              ></el-input>
            </el-form-item>
            <el-form-item label="區號">
              <el-input
                @input="
                  infoForm.userReceiveAreaCode =
                    infoForm.userReceiveAreaCode.replace(/\D+/g, '')
                "
                maxlength="50"
                v-model="infoForm.userReceiveAreaCode"
                placeholder="請輸入區號"
              ></el-input>
            </el-form-item>
            <el-form-item label="手機號碼">
              <el-input
                @input="
                  infoForm.userReceivePhone = infoForm.userReceivePhone.replace(
                    /\D+/g,
                    ''
                  )
                "
                maxlength="50"
                v-model="infoForm.userReceivePhone"
                placeholder="請輸入手機號碼"
              ></el-input>
            </el-form-item>
            <el-form-item label="發貨地址">
              <el-input
                type="textarea"
                :rows="3"
                v-model="infoForm.userReceiveAddr"
                placeholder="請輸入發貨地址"
                maxlength="150"
              ></el-input>
            </el-form-item>
            <el-form-item label="物流貨運">
              <el-input
                v-model="infoForm.trackingType"
                placeholder="請輸入物流貨運"
                maxlength="50"
              ></el-input>
            </el-form-item>
            <el-form-item label="貨運單號">
              <el-input
                v-model="infoForm.trackingNumber"
                placeholder="请输入貨運單號"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="btn" @click="changeTrackingNumber()">修改</div>
      </span>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
import { color } from "echarts/lib/theme/light";
import { backgroundColor } from "echarts/lib/theme/dark";
import { options } from "less";

export default {
  data() {
    return {
      navBlock: "訂單  /  售後訂單",
      navtitle: "查看售後",
      bigimghover: true,
      orderNum: this.$route.query.orderNum,
      id: this.$route.query.id,
      dialogVisible: false,
      orderStatus: "", //需要传值的orderStatus
      orderInfo: {},
      memberDto: {},
      payFlowDto: {},
      receiverInfo: {},
      orderDetailDto: [],
      currency: "",
      recievablePrice: "", //小计
      discountRecievablePrice: "", //折扣后小计
      extraPrice: "", //运费
      discountExtraPrice: "", //折扣后运费
      receiptsPrice: "", //总价
      remark: "", //备注
      editmodal: false, //编辑弹窗
      editshopmodal: false, //商品信息弹窗
      editAddress: false, //编辑地址弹窗
      editwuliuModal: false,
      addressType: "success", //默認展示
      ruleForm: {
        trackingCompany: "",
        trackingNumber: "",
        receiver: "",
        receivePhone: "",
        receiveCode: "",
        country: "",
        city: "",
        region: "",
        receiverAddress: "",
      },
      addressRule: {
        receiver: [
          { required: true, message: "请输入收件人姓名", trigger: "change" },
        ],
        receiveAreaCode: [
          { required: true, message: "请输入區號", trigger: "change" },
        ],
        receivePhone: [
          { required: true, message: "请输入聯係電話", trigger: "change" },
        ],
        receiveAddr: [
          { required: true, message: "请输入详细地址", trigger: "change" },
        ],
      },
      addressForm: {
        receiver: "",
        receiveAreaCode: "",
        receivePhone: "",
        receiveAddr: "",
      },
      trackingForm: {
        trackingNumber: "",
        trackingType: "",
      },
      trackingRule: {
        trackingNumber: [
          { required: true, message: "请输入貨運單號", trigger: "change" },
        ],
        trackingType: [
          { required: true, message: "请输入物流公司", trigger: "change" },
        ],
      },
      orderDetailDtoIn: [], //商品信息弹窗里的内容
      deleteDetailId: [], //商品详情删除需要传的id
      address: "",
      submitreceiverData: {},

      receiverLabel: [
        {
          label: "物流公司：",
          key: "trackingCompany",
        },
        {
          label: "貨運單號：",
          key: "trackingNumber",
        },
        {
          label: "收件人：",
          key: "receiver",
        },
        {
          label: "手機號碼：",
          key: "receivePhone",
        },
        {
          label: "郵政區號：",
          key: "receiveCode",
        },
        {
          label: "收件地址：",
          key: "receiverAddress",
        },
      ],
      payFlowDtoLabel: [
        {
          label: "付款日期：",
          key: "payTime",
        },
        {
          label: "付款方式：",
          key: "payMethod",
        },
        {
          label: "流水編號：",
          key: "payFlowId",
        },
        {
          label: "平台交易編號：",
          key: "oidPartner",
        },
      ],
      orderInfoLabel: [
        {
          label: "售後狀態：",
          key: "status",
        },
        {
          label: "處理方式：",
          key: "processingMethod",
        },
        {
          label: "售後編號：",
          key: "afterSalesNo",
        },
        {
          label: "申請時間：",
          key: "createTime",
        },
        {
          label: "售後商品",
          key: "shopInformation",
        },
      ],
      questionKind: "",
      questionDescription: "",
      addressList: [],
      infoForm: {},
      editInfoType: "",
      recordList: [],
      dto: [],
      shopInformation: [],
      infoStatus: "",
      content: "",
      contents: "",
      addressId: "",
      processingMethod: 1,
      options: [
        {
          value: 1,
          label: "寄回商品不符",
        },
        {
          value: 2,
          label: "商品缺失",
        },
        {
          value: 3,
          label: "配件缺失",
        },
        {
          value: 4,
          label: "商品存在人爲損壞",
        },
        {
          value: 5,
          label: "其他異常",
        },
      ],
    };
  },
  computed: {
    calculateRecievablePrice() {
      let result = 0;
      this.orderDetailDtoIn.map((item) => {
        result =
          result + Number(item.goodsAmount) * Number(item.goodsRecievablePrice);
      });
      return result;
    },
    calculategoodsReceiptsPrice() {
      return this.calculateRecievablePrice + Number(this.extraPrice);
    },
  },
  created() {
    let _this = this;
    _this.getOrderDetails();
    _this.getAddress();
  },
  destroyed() {
    this.$bus.$emit("refreshall");
    this.$bus.$emit("refreshout");
    this.$message.closeAll();
  },
  methods: {
    getOrderDetails() {
      let _this = this;
      _this
        .$get(
          `/request/after/sales/detail?id=${_this.id}`,
          {},
          _this.$GLOBAL.jsonConfig
        )
        .then((res) => {
          if (res.code === "00000") {
            this.orderInfo = {
              orderNum: this.$route.query.orderNum,
              status: res.data.afterSales.status,
              afterSalesNo: res.data.afterSales.afterSalesNo,
              createTime: _this.$getTime(res.data.afterSales.createTime),
              weReceiver: res.data.afterSales.weReceiver,
              weReceiveAreaCode: res.data.afterSales.weReceiveAreaCode,
              weReceivePhone: res.data.afterSales.weReceivePhone,
              weReceiveAddr: res.data.afterSales.weReceiveAddr,
              weTrackingNumber: res.data.afterSales.weTrackingNumber,
              weTrackingType: res.data.afterSales.weTrackingType,
              userReceiver: res.data.afterSales.userReceiver,
              userReceiveAreaCode: res.data.afterSales.userReceiveAreaCode,
              userReceivePhone: res.data.afterSales.userReceivePhone,
              userReceiveAddr: res.data.afterSales.userReceiveAddr,
              userTrackingNumber: res.data.afterSales.userTrackingNumber,
              userTrackingType: res.data.afterSales.userTrackingType,
              memo: res.data.afterSales.memo,
              valid: res.data.afterSales.valid,
              processingMethod: res.data.afterSales.processingMethod,
            };
            this.dto = res.data.afterSales.dto;
            this.processingMethod = res.data.afterSales.processingMethod
              ? res.data.afterSales.processingMethod
              : 1;
            this.recordList = res.data.afterSales.recordList;
            this.shopInformation = res.data.afterSales.shopInformation;
            this.receiverInfo = {
              trackingCompany: res.data.order.trackingCompany,
              trackingNumber: res.data.order.trackingNumber,
              receiver: res.data.order.receiver,
              receivePhone: res.data.order.receivePhone,
              receiveCode: res.data.order.receiveCode,
              receiverAddress: res.data.order.receiverAddress,
              country: res.data.order.country,
              city: res.data.order.city,
              region: res.data.order.region,
            };
            this.address = res.data.order.address;
            this.memberDto = res.data.order.memberDto;
            this.orderDetailDto = res.data.order.orderDetailDto;
            this.currency = res.data.order.currency;
            this.recievablePrice = res.data.order.recievablePrice;
            this.discountRecievablePrice =
              res.data.order.discountRecievablePrice;
            this.extraPrice = res.data.order.extraPrice;
            this.discountExtraPrice = res.data.order.discountExtraPrice;
            this.receiptsPrice = res.data.order.receiptsPrice;
            this.remark = res.data.order.remark;
            this.questionDescription = res.data.order.questionDescription;
            this.questionKind = res.data.order.questionKind;
            if (res.data.order.payFlowDto)
              this.payFlowDto = res.data.order.payFlowDto;
            this.orderDetailDto.map((item) => {
              if (item.goodsDetail) {
                let result = item.goodsDetail;
                if (result.includes(":")) {
                  result = result.replace(/\s/g, "");
                  item.shopleft = result.split(":")[0];
                  item.shopright = result.split(":")[1];
                  if (item.goodsSkuList.length) {
                    item.goodsSkuList.map((ite) => {
                      if (ite.attrValue == item.shopright)
                        item.shopSkuId = ite.goodsSkuId;
                    });
                  }
                } else {
                  item.shopright = result;
                }
              }
            });
          } else {
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
    subType(val) {
      switch (val) {
        case 1:
          return "寄回商品不符";
        case 2:
          return "商品缺失";
        case 3:
          return "配件缺失";
        case 4:
          return "商品存在人爲損壞";
        case 5:
          return "其他異常";
      }
    },
    getAddress() {
      this.$get(
        `/request/after/sales/address/list`,
        {},
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code == "00000") {
          this.addressList = res.data;
          if (this.addressList.length > 0) {
            this.addressId = this.addressList[0].id;
          } else {
            this.addressId = "";
          }
        } else {
          this.$propMessage(res.message, "error");
        }
      });
    },
    //删除地址
    deleteAddress(id) {
      this.$get(
        `/request/after/sales/address/del?id=${id}`,
        {},
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code == "00000") {
          this.$successMessage("刪除成功");
          this.getAddress();
        } else {
          this.$errorMessage(res.message);
        }
      });
    },
    changeStatus(val) {
      switch (val) {
        case 1:
          return "待審核";
        case 2:
          return "已取消";
        case 3:
          return "審核通過";
        case 4:
          return "審核不通過";
        case 5:
          return "補充資料";
        case 6:
          return "處理中";
        case 7:
          return "換貨異常";
        case 8:
          return "已發貨";
        case 9:
          return "已完成";
        case 10:
          return "已關閉";
      }
    },
    changeRecord(val) {
      switch (val) {
        case 0:
          return "管理員開啓訂單售後申請";
        case 1:
          return "用戶已提交售後申請，等待管理員審核。";
        case 2:
          return "用戶已取消售後申請";
        case 3:
          return "售後申請已審核通過，根據管理員設置的處理方式進入後續換貨流程";
          break;
        case 4:
          return "售後申請審核未通過，已通知用戶審核結果";
          break;
        case 5:
          return "已要求用戶補充售後資料，等待用戶提交";
          break;
        case 6:
          return "用戶已提交相關物流信息，售後申請已進入處理流程";
          break;
        case 7:
          return "商品驗收過程中發現異常";
          break;
        case 8:
          return "換貨商品已發出";
          break;
        case 9:
          return "售後流程已完成（換貨商品發出滿20日後系統自動完成）";
          break;
        case 10:
          return "管理員已關閉售後申請";
          break;
        case 11:
          return "用戶已提交補充資料及憑證，等待處理";
          break;
        case 12:
          return "用戶已補充異常處理信息";
          break;
        case 13:
          return "管理員已補充異常處理說明";
          break;
        case 14:
          return "用戶超過規定時間未完成相關操作，系統自動關閉售後申請";
          break;
        case 15:
          return "管理員已完成售後申請。處理原因：";
          break;
      }
    },
    //重置备注
    reset() {
      this.remark = "";
    },
    cancelAddress() {
      this.addressType = "success";
      this.$refs["addressForm"].resetFields();
    },
    //修改退換貨信息
    changeInfo(type) {
      if (type == "huanhuo") {
        this.infoForm = {
          id: this.id,
          trackingNumber: this.orderInfo.weTrackingNumber,
          trackingType: this.orderInfo.weTrackingType,
          userReceiveAddr: this.orderInfo.userReceiveAddr,
          userReceivePhone: this.orderInfo.userReceivePhone,
          userReceiveAreaCode: this.orderInfo.userReceiveAreaCode,
          userReceiver: this.orderInfo.userReceiver,
        };
      } else {
        this.infoForm = {
          id: this.id,
          userTrackingNumber: this.orderInfo.userTrackingNumber,
          userTrackingType: this.orderInfo.userTrackingType,
          weReceiveAddr: this.orderInfo.weReceiveAddr,
          weReceivePhone: this.orderInfo.weReceivePhone,
          weReceiveAreaCode: this.orderInfo.weReceiveAreaCode,
          weReceiver: this.orderInfo.weReceiver,
        };
      }
      this.editInfoType = type;
      this.editwuliuModal = true;
    },
    // 关闭售后
    delCalendar() {
      let _this = this;
      let data = { id: _this.id, status: "10" };
      _this
        .$confirm(
          "確認關閉該售後申請？關閉后售後流程將結束，用戶將無法繼續當前售後申請。",
          "提示",
          {
            confirmButtonText: "確認",
            cancelButtonText: "取消",
            center: true,
            closeOnClickModal: false,
          }
        )
        .then(() => {
          // 确认删除的回调
          _this
            .$post("/request/after/sales/modify", data, this.$GLOBAL.jsonConfig)
            .then((res) => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage("關閉成功", "success", function () {
                  _this.dialogVisible = false;
                  _this.getOrderDetails();
                });
              } else {
                _this.$propMessage(res.message, "error", function () {
                  _this.dialogVisible = false;
                });
              }
            });
        });
    },
    //收件人恢复默认
    resetDefault() {
      let current = JSON.parse(JSON.stringify(this.receiverInfo));
      current.receiverAddress = this.address;
      this.ruleForm = current;
    }, //商品详情恢复默认
    resetDefaultshop() {
      let current = JSON.parse(JSON.stringify(this.orderDetailDto));
      this.orderDetailDtoIn = current;
      this.deleteDetailId = [];
    },
    //确认保存
    handleSave() {
      this.handleChangeOrder("save");
    },
    //修改處理方式
    changeMethod() {
      if (!this.contents && this.processingMethod == 2) {
        this.$errorMessage("請輸入留言");
        return;
      }
      this.dialogVisible = true;
      this.$post(
        `/request/after/sales/modify/method`,
        {
          id: this.id,
          content: this.processingMethod == 1 ? this.content : this.contents,
          addressId: this.processingMethod == 1 ? this.addressId : null,
          processingMethod:
            this.processingMethod == this.orderInfo.processingMethod
              ? null
              : this.processingMethod,
        },
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        this.dialogVisible = false;
        this.editAddress = false;
        this.content = "";
        this.contents = "";
        if (res.code == "00000") {
          this.$successMessage("修改成功");
          this.getOrderDetails();
        } else {
          this.$errorMessage(res.message);
        }
      });
    },
    //保存地址
    submitAddress(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$post(
            `/request/after/sales/address/add`,
            this.addressForm,
            this.$GLOBAL.jsonConfig
          ).then((res) => {
            this.dialogVisible = true;
            if (res.code == "00000") {
              this.$successMessage("新增地址成功");
              this.getAddress();
              this.addressType = "success";
              this.dialogVisible = false;
              this.$refs[formName].resetFields();
            } else {
              this.dialogVisible = false;
              this.$errorMessage(res.message);
            }
          });
        } else {
          return false;
        }
      });
    },
    changeOrder() {
      if (this.addressType == "yichangliuyan") {
        if (!this.content) {
          this.$errorMessage("請提示用戶物流異常原因");
          return;
        }
        this.dialogVisible = true;
        this.$post(
          `/request/after/sales/reply`,
          {
            id: this.id,
            content: this.content,
          },
          this.$GLOBAL.jsonConfig
        ).then((res) => {
          if (res.code == "00000") {
            this.getOrderDetails();
            this.$successMessage("操作成功");
            this.editAddress = false;
            this.dialogVisible = false;
          } else {
            this.dialogVisible = false;
            this.$errorMessage(res.message);
          }
        });
        return;
      }
      if (this.addressType == "yichang" && !this.content) {
        this.$errorMessage("請提示用戶物流異常原因");
        return;
      }
      if (this.addressType == "chuli" && !this.content) {
        this.$errorMessage("請填寫本次售後的最終處理說明");
        return;
      }
      if (this.addressType == "success" && !this.addressId) {
        this.$errorMessage("請選擇退回地址");
        return;
      }
      if (this.addressType == "success" && this.processingMethod == 2) {
        if (!this.contents) {
          this.$errorMessage("請輸入留言");
          return;
        }
      }
      if (this.addressType == "fahuo") {
        if (!this.trackingForm.trackingType) {
          this.$errorMessage("请输入物流公司");
          return;
        }
        if (!this.trackingForm.trackingNumber) {
          this.$errorMessage("请输入貨運單號");
          return;
        }
      }
      const data = {
        id: this.id,
        status: this.infoStatus,
        addressId:
          this.orderInfo.status == 1 && this.processingMethod == 1
            ? this.addressId
            : null,
        content:
          this.infoStatus == 3
            ? this.processingMethod == 1
              ? this.content
              : this.contents
            : this.content,
        trackingNumber: this.trackingForm.trackingNumber,
        trackingType: this.trackingForm.trackingType,
        processingMethod:
          this.infoStatus == 3 || this.infoStatus == 7
            ? this.processingMethod
            : null,
      };
      this.$post(
        `/request/after/sales/modify`,
        data,
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        this.dialogVisible = true;
        if (res.code == "00000") {
          this.getOrderDetails();
          this.$successMessage("操作成功");
          this.editAddress = false;
          this.dialogVisible = false;
        } else {
          this.dialogVisible = false;
          this.$errorMessage(res.message);
        }
      });
    },
    showModal(type, status) {
      if (status == "3") {
        this.processingMethod = 1;
      } else {
        this.processingMethod = "";
      }
      this.addressType = type;
      this.infoStatus = status;
      this.content = "";
      this.contents = "";
      this.editAddress = true;
    },
    changeShowModal(type) {
      this.editAddress = true;
      this.addressType = type;
      this.content = "";
      if (this.orderInfo.processingMethod == 2) {
        this.contents = this.orderInfo.memo;
      }
    },
    //编辑弹窗
    showEdit() {
      this.resetDefault();
      this.editmodal = true;
    },
    //修改物流信息
    changeTrackingNumber() {
      if (this.editInfoType == "tuihui") {
        if (!this.infoForm.weReceiver) {
          this.$errorMessage("请输入收件人");
          return;
        }
        if (!this.infoForm.weReceiveAreaCode) {
          this.$errorMessage("請輸入區號");
          return;
        }
        if (!this.infoForm.weReceivePhone) {
          this.$errorMessage("請輸入手機號碼");
          return;
        }
        if (!this.infoForm.weReceiveAddr) {
          this.$errorMessage("請輸入退回地址");
          return;
        }
        if (
          !this.infoForm.userTrackingType &&
          this.orderInfo.userTrackingType
        ) {
          this.$errorMessage("請輸入退回物流公司");
          return;
        }
        if (
          !this.infoForm.userTrackingNumber &&
          this.orderInfo.userTrackingNumber
        ) {
          this.$errorMessage("請輸入退回貨運單號");
          return;
        }
      } else {
        if (!this.infoForm.userReceiver) {
          this.$errorMessage("请输入收件人");
          return;
        }
        if (!this.infoForm.userReceiveAreaCode) {
          this.$errorMessage("請輸入區號");
          return;
        }
        if (!this.infoForm.userReceivePhone) {
          this.$errorMessage("請輸入手機號碼");
          return;
        }
        if (!this.infoForm.userReceiveAddr) {
          this.$errorMessage("請輸入發貨地址");
          return;
        }
        if (!this.infoForm.trackingType && this.orderInfo.weTrackingType) {
          this.$errorMessage("請輸入物流貨運");
          return;
        }
        if (!this.infoForm.trackingNumber && this.orderInfo.weTrackingNumber) {
          this.$errorMessage("请输入貨運單號");
          return;
        }
      }
      // return
      this.$post(
        `/request/after/sales/modify/logistics`,
        this.infoForm,
        this.$GLOBAL.jsonConfig
      ).then((res) => {
        if (res.code == "00000") {
          this.$successMessage("修改成功");
          this.getOrderDetails();
          this.editwuliuModal = false;
        } else {
          this.$errorMessage(res.message);
        }
      });
    },
    //修改订单方法
    handleChangeOrder(type, typeedit) {
      let _this = this;
      let param = {
        orderNum: this.$route.query.orderNum,
        remark: this.remark,
      };
      if (typeedit === "changestatus") {
        param = { ...param, orderStatus: this.orderStatus };
      } else if (typeedit === "edit") {
        param = {
          ...param,
          trackingCompany: this.submitreceiverData.trackingCompany,
          trackingNumber: this.submitreceiverData.trackingNumber,
          receiver: this.submitreceiverData.receiver,
          receivePhone: this.submitreceiverData.receivePhone,
          receiveCode: this.submitreceiverData.receiveCode,
          country: this.submitreceiverData.country,
          city: this.submitreceiverData.city,
          region: this.submitreceiverData.region,
          address: this.submitreceiverData.receiverAddress,
        };
      } else if (typeedit === "editshop") {
        let orderDetailRequest = [];
        this.orderDetailDtoIn.map((item) => {
          if (item.goodsDetail) {
            let current = {
              id: item.id,
              num: item.goodsAmount,
              goodsDetail: item.shopleft
                ? item.shopleft + ": " + item.shopright
                : item.shopright,
            };
            if (item.goodsSkuList.length) {
              if (item.shopSkuId) {
                current = {
                  ...current,
                  skuId: item.shopSkuId,
                };
              }
            }
            orderDetailRequest.push(current);
          } else {
            orderDetailRequest.push({
              id: item.id,
              num: item.goodsAmount,
            });
          }
        });
        param = {
          ...param,
          orderDetailRequest,
          deleteDetailId: this.deleteDetailId,
        };
      }
      _this
        .$post("/request/order/v2/editOrder", param, _this.$GLOBAL.jsonConfig)
        .then((res) => {
          if (res.code === "00000") {
            _this.dialogVisible = true;
            _this.$propMessage(
              type === "save" ? "更改訂單詳情成功" : "更改訂單狀態成功",
              "success",
              function () {
                _this.dialogVisible = false;
              }
            );
            _this.editmodal = false;
            _this.editshopmodal = false;
            _this.getOrderDetails();
          } else {
            if (type !== "save") {
              this.orderStatus = undefined;
            }
            _this.dialogVisible = true;
            _this.$propMessage(res.message, "error", function () {
              _this.dialogVisible = false;
            });
          }
        });
    },
  },
  components: {
    NavBar,
    DiaMess,
  },
};
</script>

<style lang="less" scoped>
.rowdelete {
  display: flex;
  align-items: center;
  .rowdeleteTitle {
    color: rgba(41, 41, 41, 1);
    font-size: 14px;
    font-weight: 500;
    margin-left: 8px;
  }
}
.line {
  height: 0.5px;
  background: rgba(238, 238, 238, 1);
  width: 100%;
  margin-top: 9px;
  margin-bottom: 9px;
}
.el-button--mini {
  padding: 5px 9px;
}
.contentDetails {
  .paddingContent {
    width: 100%;
    overflow: auto;
    background: none;
  }
  .box-card {
    width: 100%;
    min-width: 300px;
    background: #fafafd;
    border-radius: 12px;
    margin-bottom: 44px;
    .cardHeader {
      height: 68px;
      background: #f2f2f6;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-top: 3px solid #e5e4ea;
      padding: 20px;
      border-top-left-radius: 3px;
      border-top-right-radius: 3px;
      .cardHeaderLeft {
        font-size: 0.16rem;
        color: #6c3dea;
      }
      .cardHeaderRight_edit {
        padding: 5px 16px;
        border: 1px solid #6c3dea;
        border-radius: 4px;
        color: #6c3dea;
        cursor: pointer;
      }
    }
    .cardBody {
      padding: 20px;
      .cardRow {
        display: flex;
        .cardRowLeft {
          color: #938ea4;
          font-size: 0.14rem;
          text-align: left;
          width: 140px;
          flex-shrink: 0;
        }
        .allpointer {
          div {
            cursor: pointer !important;
          }
        }
        .cardRowRight {
          color: #292929;
          font-size: 0.14rem;
          text-align: left;
          word-break: break-all;
        }
        .cardRowRight_status {
          padding: 4px 8px;
          background: #6c3dea;
          color: #ffffff;
          font-size: 0.14rem;
          border-radius: 4px;
        }
        .coverbig {
          width: 80px;
          height: 80px;
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 4px;
          background: rgba(41, 41, 41, 1);
          opacity: 0.6;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .shoplist {
    .shoplist_top {
      text-align: left;
      color: #292929;
      font-size: 0.14rem;
    }
    .shoplist_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      .shoplist_detail {
        color: #292929;
        opacity: 0.6;
        font-size: 0.12rem;
      }
      .shoplist_num {
        color: #938ea4;
        font-size: 0.14rem;
      }
      .shoplist_price {
        color: #878399;
        font-size: 0.14rem;
        text-align: right;
        position: relative;
      }
    }
    .shoprow {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .shoplist_topin {
        font-size: 0.14rem;
        color: #121212;
        font-weight: 500;
      }
      .shopdetail {
        display: flex;
        align-items: center;
        font-size: 0.14rem;
        flex-shrink: 0;
        span {
          font-size: 0.14rem;
          color: #292929;
          opacity: 0.6;
        }
      }
    }
    .shopprice {
      color: #6c3dea;
      opacity: 0.8;
      font-size: 0.14rem;
      text-align: right;
      font-weight: 500;
    }
  }
  .shopinback {
    background: #f5f5fc;
    border-radius: 4px;
    padding: 23px 12px 23px 12px;
    margin-top: 27px;
  }
  .line {
    height: 0.5px;
    background: #d9d7e0;
    width: 100%;
    margin-top: 32px;
  }
  .linee {
    height: 0.5px;
    background: #eeeeee;
    width: 100%;
    margin-top: 25px;
  }
  .shop_row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .texttypelow {
      color: #292929;
      opacity: 0.6;
      font-size: 0.14rem;
    }
    .typeinlow {
      color: #938ea4;
      font-size: 0.14rem;
    }
    .texttypemiddle {
      color: #292929;
      opacity: 0.6;
      font-size: 0.14rem;
    }
    .texttypedeep {
      color: #292929;
      opacity: 1;
      font-size: 0.14rem;
    }
  }
  .remark_box {
    width: 100%;
    min-width: 300px;
    background: #fafafd;
    border-radius: 12px;
    margin-bottom: 44px;
    padding: 20px;
    .remark_box_button {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
    }
    .remark_box_input {
      display: flex;
    }
    .remark_box_text {
      color: #292929;
      font-size: 0.14rem;
    }
  }
  /deep/ .el-dialog {
    border-radius: 12px;
  }
  /deep/ .el-dialog__header {
    border-bottom: 1px solid #eeeeee;
  }
  .formpadding {
    padding-left: 11px;
    /deep/ .el-form-item__content {
      margin-left: 9px !important;
    }
  }
  /deep/ .el-form-item__content {
    margin-left: 20px !important;
  }
  /deep/ .el-form-item__label:before {
    color: #6c3dea !important;
  }
  /deep/ .el-form-item__label {
    flex-shrink: 0;
  }
  /deep/ .el-form {
    padding-left: 0rem;
  }
  .threeinline {
    display: flex;
    align-items: center;
    /deep/ .el-form-item__content {
      width: 90px;
    }
    /deep/ .el-form-item {
      margin-right: 0px;
    }
  }
  .addressdetail {
    /deep/ .el-form-item__content {
      margin-left: 120px !important;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media screen and (min-width: 934px) {
    .paddingContent {
      min-width: 800px;
      overflow: auto;
      .contentbox {
        display: flex;
      }
      .contentLeft {
        width: 48%;
      }
      .contentRight {
        width: 48%;
        margin-left: 4%;
      }
    }
  }
  @media screen and (max-width: 934px) {
    .paddingContent {
      min-width: 500px;
      overflow: auto;
      .contentbox {
        display: block;
      }
      .contentLeft {
        width: 100%;
      }
      .contentRight {
        width: 100%;
      }
    }
  }
}
.chart_input {
  width: 100%;
  flex: 1;
  height: 114px;
  box-sizing: border-box;
  outline: none;
  padding: 10px;
  resize: none;
  color: #000000;
  font-size: 14px;
  background-color: #e8e6f0;
  border: none;
  border-radius: 4px;
}
.address_input {
  width: 300px;
  height: 70px;
  box-sizing: border-box;
  border: 1px solid #dcdfe6;
  outline: none;
  padding: 10px;
  resize: none;
  color: rgba(147, 142, 164);
  font-size: 14px;
}
/deep/.el-radio__label {
  color: #606266;
}
.tui_btn {
  width: "100%";
  height: 70px;
  background: #f3f3fb;
  border-radius: 4px;
  color: #5938e0;
  line-height: 70px;
  text-align: center;
  cursor: pointer;
}
.recordList {
  padding: 8px 20px;
  background: #f3f3fb;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.goodBox {
  border: 1px solid #d3d1db;
  border-radius: 4px;
  width: 100%;
}
.good_item {
  display: flex;
  align-items: center;
  padding: 13px 0 13px 13px;
  border-right: 1px solid #d3d1db;
  flex: 1;
  img {
    margin-right: 15px;
  }
}
.good_num {
  width: 80px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.good_head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.recordBoxWeight {
  width: 12px;
  height: 12px;
  background: #5938e0;
  border-radius: 6px;
  margin-right: 100px;
}
.recordBox {
  width: 12px;
  height: 12px;
  background: #5938e0;
  border-radius: 6px;
  margin-right: 100px;
  opacity: 0.2;
}
.commonText {
  font-size: 0.14rem;
  color: #878399;
}
/deep/ .el-radio__label {
  color: #606266;
}
/deep/ .el-radio__input.is-checked + .el-radio__label {
  color: #606266;
}
.xiugaibox {
  width: 58px;
  height: 32px;
  background: #5938e0;
  border-radius: 4px;
  text-align: center;
  line-height: 32px;
  color: #ffffff;
}
/deep/ .el-textarea__inner {
  height: 100px;
  line-height: 20px;
  width: 100%;
}
.changeMethd {
  width: 58px;
  height: 32px;
  background: #5938e0;
  border-radius: 4px;
  text-align: center;
  line-height: 32px;
  font-size: 13px;
  color: #ffffff;
  margin-left: 20px;
  cursor: pointer;
}
.priceLine {
  width: 100%;
  height: 1px;
  background-color: #878399;
  position: absolute;
  bottom: 7px;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/allOrder/afterSalesDetails.vue